import { render } from "./ApresentarLinhaColunas.vue?vue&type=template&id=3bece172&scoped=true&ts=true"
import script from "./ApresentarLinhaColunas.vue?vue&type=script&lang=ts"
export * from "./ApresentarLinhaColunas.vue?vue&type=script&lang=ts"

import "./ApresentarLinhaColunas.vue?vue&type=style&index=0&id=3bece172&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bece172"]])

export default __exports__